export default __webpack_public_path__ + "static/media/BVCER_SansQR-ISO 9001 B&W.4900474e.png";